import { Offer, NameBanner, Button } from '@rumblefish/ui/Rumblefish23Theme';
import KarolinaImg from '../../../public/webp/fromPNG/team/Karolina.webp';
import { handleScroll } from '../../../utils/handleScroll';
import { recruitmentProcessData } from './RecruitmentProcess.data';
import type { RecruitmentProcessServicesProps } from './RecruitmentprocessServices.types';
import {
  StyledStack,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';
export const RecruitmentProcess = ({
  ...props
}: RecruitmentProcessServicesProps): React.ReactElement => {
  const customThresholds = [0, 32, 54, 70, 90];

  const scrollToContactForm = () => {
    const targetElement = document.getElementById('contact-form');
    if (targetElement) {
      handleScroll({ current: targetElement });
    }
  };
  return (
    <>
      <StyledSection width="normal" id="recruitment-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="Recruitment process"
              color="orange"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>
      <Offer
        title={recruitmentProcessData.mainText}
        description={recruitmentProcessData.description}
        data={recruitmentProcessData.services}
        height={'240px'}
        image={KarolinaImg}
        thresholds={customThresholds}
        CustomButton={
          props.onSubmit ? (
            <Button
              secondaryVariant
              shadowColor="orange"
              onClick={props.onSubmit}>
              Submit your application
            </Button>
          ) : (
            <StyledLinkWrapper>
              <Button
                secondaryVariant
                shadowColor="orange"
                onClick={scrollToContactForm}>
                Submit your application
              </Button>
            </StyledLinkWrapper>
          )
        }
      />
    </>
  );
};
